// src/components/ItemCardCategoryList.jsx
import { useEffect, useState } from "react";
import { fetchItems } from "../utils/fetchItems";
import useSortedItems from "../hooks/useSortedItems"; // 商品のソートロジック
import CategoryListRenderer from "./CategoryListRenderer"; // ここでCategoryListRendererをインポート

const ItemCardCategoryList = ({ categoryId, subcategoryId, seriesId }) => {
 const [items, setItems] = useState([]);
 const [totalItemsCount, setTotalItemsCount] = useState(0);

 useEffect(() => {
  const fetchData = async () => {
   const data = await fetchItems();
   // カテゴリまたはシリーズでフィルタリング
   const filteredItems = data.filter((item) => item.item_category === categoryId || item.item_subcategory === subcategoryId || item.item_series === seriesId);

   setItems(filteredItems);
   setTotalItemsCount(data.length);
  };

  fetchData();
 }, [categoryId, subcategoryId, seriesId]);

 // 商品のソートロジック
 const sortedItems = useSortedItems(items); // フィルタリングされたアイテムをソート

 return <CategoryListRenderer categoryId={categoryId} subcategoryId={subcategoryId} seriesId={seriesId} items={sortedItems} totalItemsCount={totalItemsCount} />;
};

export default ItemCardCategoryList;
